import NextHead from 'next/head'

interface MetaRobotsProps {
  index: boolean
  follow: boolean
}

export function MetaRobots({ index, follow }: MetaRobotsProps) {
  return (
    <NextHead>
      <meta name="robots" content={`${index ? 'index' : 'noindex'},${follow ? 'follow' : 'nofollow'}`} />
    </NextHead>
  )
}
